// Generated by purs version 0.14.5
"use strict";
var lift = function (dict) {
    return dict.lift;
};
module.exports = {
    lift: lift
};
